import React from 'react';
import { IResetableFormRenderProps } from 'sellDirect/components/closingDash/ResetableForm';
import {
  isServiceProvidersFormComplete,
  isServiceProvidersFormValid,
} from 'sellDirect/helpers/closingDash/serviceProviders';
import { SaveButton } from 'sellDirect/components/closingDash/form/SaveButton';
import { ClosingTasks } from 'sellDirect/helpers/closingTasks';
import { UtilitiesFormContent } from 'sellDirect/components/closingDash/serviceProviders/UtilitiesFormContent';
import { OtherServicesFormContent } from 'sellDirect/components/closingDash/serviceProviders/OtherServicesFormContent';
import { ServiceProvidersFormState } from 'sellDirect/components/closingDash/serviceProviders/ServiceProvidersForm';

interface IProps {
  shouldSeeAgentExperience: boolean;
  closingTasks: ClosingTasks;
  loading?: boolean;
  onCancel?: () => void;
  resetableForm: IResetableFormRenderProps;
}

/**
 * Editable service providers form.
 * component-test-check-ignore
 * storybook-check-ignore
 */
export const ServiceProvidersFormContent: React.FC<IProps> = ({
  shouldSeeAgentExperience,
  closingTasks,
  loading,
  onCancel,
  resetableForm,
}) => {
  const { onSubmit } = resetableForm;
  const formState: ServiceProvidersFormState = resetableForm.formState;

  return (
    <>
      <UtilitiesFormContent
        shouldSeeAgentExperience={shouldSeeAgentExperience}
        closingTasks={closingTasks}
        resetableForm={resetableForm}
        loading={loading}
      />
      <OtherServicesFormContent
        shouldSeeAgentExperience={shouldSeeAgentExperience}
        closingTasks={closingTasks}
        resetableForm={resetableForm}
        loading={loading}
      />
      <SaveButton
        containerProps={{ my: 9 }}
        analyticsPrefix="service-providers-form-"
        loading={loading}
        disabled={isServiceProvidersFormValid(formState) ? false : true}
        onClick={onSubmit}
        onCancel={onCancel}
        hideCancel={!isServiceProvidersFormComplete(closingTasks)}
        aria-label="Save service providers and close"
      />
    </>
  );
};
